import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectRequirementApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'project-requirement'
  }

}